import React from 'react';
import bg from '../../../assets/QQPenguin_gg/bg.png';
import GG0 from '../../../assets/QQPenguin_gg/icon_00.png';
import checkbutton from '../../../assets/QQPenguin_gg/Button_check_01.png';
import checkedbutton from '../../../assets/QQPenguin_gg/Button_check_03.png';
import minbutton from '../../../assets/QQPenguin_gg/Button_min_00.bmp';
import closebutton from '../../../assets/QQPenguin_gg/Button_close_00.png';
import ok from '../../../assets/QQPenguin_gg/Button_00.png';
import './qqpet.css';

export default class QQPetLogin extends React.Component {
  constructor(props) {
    super(props);
    this.state = { save: true };
  }

  check = () => {
    this.props.checkfunc();
  };

  save = () => {
    this.setState({ save: !this.state.save });
  };

  startPets = () => {
    if (this.props.checkstate) {
      if (!this.props.petstate) {
        this.props.onClose();
        this.props.petfunc();
      } else {
        this.props.onClose();
        alert('你已经登录一只宠物了，不要太贪心噢！');
      }
    }
  };

  render() {
    return (
      <div
        style={{
          left: `50%`,
          top: `50%`,
          transform: `translate(-50%,80%)`,
          width: `330px`,
          height: `229px`,
          backgroundImage: `url(${bg})`,
          position: `absolute`,
        }}
      >
        <div>
          <div
            id="close"
            style={{
              border: `none`,
              width: `38px`,
              height: `18px`,
              backgroundImage: `url(${closebutton})`,
              backgroundRepeat: 'no-repeat',
              backgroundSize: `100% 100%`,
              display: `inline`,
              float: `right`,
            }}
            onMouseUp={this.props.onClose}
          ></div>
          <div
            id="min"
            style={{
              border: `none`,
              width: `25px`,
              height: `18px`,
              backgroundImage: `url(${minbutton})`,
              backgroundRepeat: 'no-repeat',
              backgroundSize: `100% 100%`,
              display: `inline`,
              float: `right`,
            }}
            onMouseUp={this.props.onMinimize}
          ></div>
        </div>
        <div
          onClick={this.check}
          id="gg"
          style={{
            left: `50%`,
            top: `50%`,
            transform: `translate(-50%,-50%)`,
            width: `135px`,
            height: `136px`,
            backgroundImage: `url(${GG0})`,
            position: `absolute`,
          }}
        ></div>
        <div
          onClick={this.check}
          id="check"
          style={{
            left: `50%`,
            top: `50%`,
            transform: `translate(-50%,350%)`,
            width: `78px`,
            height: `17px`,
            backgroundImage: this.props.checkstate
              ? `url(${checkedbutton})`
              : `url(${checkbutton})`,
            backgroundRepeat: 'no-repeat',
            position: `absolute`,
            textAlign: `right`,
          }}
        >
          <div style={{ marginTop: '-2.5px' }}>Q宠宝贝</div>
        </div>
        <div
          onClick={this.save}
          id="save"
          style={{
            left: `50%`,
            top: `50%`,
            transform: `translate(-140%,510%)`,
            width: `110px`,
            height: `17px`,
            backgroundImage: this.state.save
              ? `url(${checkedbutton})`
              : `url(${checkbutton})`,
            backgroundRepeat: 'no-repeat',
            position: `absolute`,
            textAlign: `right`,
          }}
        >
          <div style={{ marginTop: '-2px' }}>记住我的选择</div>
        </div>
        <div
          onClick={this.startPets}
          id="ok"
          style={{
            border: `none`,
            left: `50%`,
            top: `50%`,
            transform: `translate(100%,410%)`,
            width: `69px`,
            height: `21px`,
            backgroundImage: `url(${ok})`,
            backgroundRepeat: 'no-repeat',
            position: `absolute`,
            textAlign: `center`,
          }}
        >
          确定
        </div>
      </div>
    );
  }
}
